import React, { useEffect, useState } from "react";
import { get_tipostelas } from "../../../../actions/produccion";
import { SearchBasicSelectUI } from "../../../ui/SearchBasicSelectUI";

export const TipoTelaSelect = ({ ...restProps }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const OnLoad = async () => {
      const data = await get_tipostelas();
      setItems(data);
    };
    OnLoad();
    return () => {
      setItems([]);
    };
  }, []);

  return <SearchBasicSelectUI data={items} {...restProps} />;
};
